import React from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import "./style.scss";
import { useTranslation } from "react-i18next";

const CheckWrap = ({ handleSubmit, loading }) => {
  const { t } = useTranslation();

  return (
    <Grid className="cardbp mt-20">
      <Grid>
        <Grid item xs={12}>
          <Grid className="formFooter mt-20">
            <Button
              fullWidth
              className="title cBtn cBtnLarge cBtnTheme mt-20"
              type="button"
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? t("loading") :t(`proceedToCheckout`)}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CheckWrap;
